import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation  } from "react-router-dom";

import styles from  "./selectLanguage.module.less";

function SelectLanguage() {

  const languagesContentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const {i18n} = useTranslation();
  const navigate = useNavigate();
  const location  = useLocation ();

  function handleClick(){
    setIsOpen(!isOpen);
  }
  
  function handleSelectLanguage(language){
    setIsOpen(false);
    const newpath=location.pathname.replace('/'+i18n.language+'/','/'+language+'/')
    i18n.changeLanguage(language);
    navigate(newpath);
  }

  const handleClickOutside = (event) => {
    if (languagesContentRef.current) {
      if (languagesContentRef.current.contains(event.target)) return;
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={styles.selectLanguages}>
      <div className={styles.languageActive} onClick={handleClick}>
        {i18n.language === 'en' && <i className={styles.flagEN}></i>}
        {i18n.language === 'es' && <i className={styles.flagES}></i>}
        {i18n.language === 'de' && <i className={styles.flagDE}></i>}
        <i className={styles.arrow}></i>
      </div>

      {i18n.language === 'en' && (
        <div ref={languagesContentRef} className={[styles.languagesContent, isOpen ? styles.active : ""].join(" ")}>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("es")}><i className={styles.flagES}></i></a></div>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("de")}><i className={styles.flagDE}></i></a></div>
        </div>
      )}

      {i18n.language === 'es' && (
        <div ref={languagesContentRef} className={[styles.languagesContent, isOpen ? styles.active : ""].join(" ")}>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("en")}><i className={styles.flagEN}></i></a></div>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("de")}><i className={styles.flagDE}></i></a></div>
        </div>
      )}

      {i18n.language === 'de' && (
        <div ref={languagesContentRef} className={[styles.languagesContent, isOpen ? styles.active : ""].join(" ")}>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("en")}><i className={styles.flagEN}></i></a></div>
          <div className={styles.language}><a onClick={()=>handleSelectLanguage("es")}><i className={styles.flagES}></i></a></div>
        </div>
      )}

    </div>
  );
}

export default SelectLanguage;

